import React from 'react';
import ReactDOM from 'react-dom';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';
import AreaStaticChip from '@ifeng-fe/container_content/common/client/components/areaStaticChip';

class Affix extends React.PureComponent {
    static propTypes = {
        allowComment: PropTypes.bool,
        content: PropTypes.object,
    };

    state = {
        isShow: false,
    };

    componentDidMount() {
        this.unHandleSrcoll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.unHandleSrcoll();
    }

    handleComment = () => {
        const {
            content: { base62Id },
        } = this.props;

        if (window) window.open(`//gentie.ifeng.com/c/comment/${base62Id}`);
    };

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        // 兼容各主流浏览器
        const currentTop =
            document.documentElement.scrollTop || (window && window.pageYOffset) || document.body.scrollTop;

        if (currentTop > 100) {
            this.setState({ isShow: true });
        } else {
            this.setState({ isShow: false });
        }
    };

    /**
     * 回到顶部
     */
    backToTop = () => {
        scrollTo(0, 0);
    };

    /**
     * 渲染组件
     */
    render() {
        const { isShow } = this.state;
        const {
            allowComment,
            content: { chipObj, floatAd },
        } = this.props;

        const affix = (
            <React.Fragment>
                <div className={styles.affix_box}>
                    <div className={styles.bottom_affix}>
                        <a className={styles.backToHome} href="//www.ifeng.com/" />
                        {allowComment ? <span className={styles.comment} onClick={this.handleComment} /> : ''}
                        <a className={styles.feedback} href="//help.ifeng.com/" target="_blank" />
                        {isShow ? <span className={styles.backToTop} onClick={this.backToTop} /> : ''}
                    </div>
                </div>
                <Chip
                    id={chipObj.floatAd}
                    type="static"
                    title="浮动广告"
                    groupName="浮动"
                    translate="handleAreaAd"
                    content={floatAd}>
                    <AreaStaticChip styleName={styles.float_box} />
                </Chip>
            </React.Fragment>
        );

        return ReactDOM.createPortal(affix, document.body);
    }
}

export default errorBoundary(Affix);
